module.exports = __webpack_public_path__ + "img/playlist-1.3bdd3aca.svg";